import { render, staticRenderFns } from "./lexis-bridger.html?vue&type=template&id=0b6a92dc&scoped=true&"
import script from "./lexis-bridger.js?vue&type=script&lang=js&"
export * from "./lexis-bridger.js?vue&type=script&lang=js&"
import style0 from "./lexis-bridger.scss?vue&type=style&index=0&id=0b6a92dc&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=0b6a92dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6a92dc",
  null
  
)

export default component.exports